
import { Component } from 'vue-property-decorator';
import AffiliateNetworkCreateForm from './create.vue';
import { pick } from 'lodash';

@Component
export default class DuplicateAffNetDialog extends AffiliateNetworkCreateForm {
  child: boolean = true;

  get modalTitle(){
    return this.t('Duplicate affiliate network')
  }

  async loadData() {
    this.$store.commit('loading', true);
    this.affiliate_network_id = this.$store.getters.selectedItem.id;

    await this.affiliateNetworkApi.get(this.affiliate_network_id).then((data: any) => {
      this.form = pick(data, [
        'name',
        'tags',
        'status',
        'acceptDoublePostbacks',
        'appendClickId',
        'clickIdParam',
        'postbackOnlyWhiteIps',
        'hasCustomParamMasking',
        'postbackStatusChargeback',
        'postbackStatusConfirm',
        'postbackStatusDecline',
        'postbackStatusDefault',
        'postbackStatusNew',
        'postbackWhiteIps',
        'usePostbackStatuses',
        'workspaceId'
      ]);

      if(data.templateId && data.affiliateNetworkTemplate) {
        this.form.templateId = data.templateId;
        this.form.clickIdPlaceholder = data.affiliateNetworkTemplate.clickIdPlaceholder || this.defaultAffiliateNetworkTemplate.clickIdPlaceholder;
        this.form.payoutPlaceholder = data.affiliateNetworkTemplate.payoutPlaceholder || this.defaultAffiliateNetworkTemplate.payoutPlaceholder;
        this.form.transactionIdPlaceholder = data.affiliateNetworkTemplate.transactionIdPlaceholder || this.defaultAffiliateNetworkTemplate.transactionIdPlaceholder;
        this.form.statusPlaceholder = data.affiliateNetworkTemplate.statusPlaceholder || this.defaultAffiliateNetworkTemplate.statusPlaceholder;
      } else {
        Object.assign(this.form, this.defaultAffiliateNetworkTemplate);
      }
      
      return data;
    });


    this.form.name = this.form.name + ' (' + this.t('____x.copy') + ')';
    this.affiliate_network_id = '';
    this.oldHash = this.getCurrentHash();
    this.show = true;
    this.$store.commit('loading', false);
  }
}
